/* tslint:disable */
/* eslint-disable */
/**
 * SBL API Glommen Mjøsen Skog
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */



/**
 * 
 * @export
 * @enum {string}
 */

export const ActionModelsLibraryBaseResponsibleParty = {
    NotRelevant: 'NotRelevant',
    ForestOwner: 'ForestOwner',
    GmSkogSa: 'GMSkogSA'
} as const;

export type ActionModelsLibraryBaseResponsibleParty = typeof ActionModelsLibraryBaseResponsibleParty[keyof typeof ActionModelsLibraryBaseResponsibleParty];



